export default "__VITE_ASSET__CBFBEpcn__"